/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsCollection = {
  init: function($section) {

    // Add settings from schema to current object
    window.PXUTheme.jsCollection = $.extend(this, window.PXUTheme.getSectionData($section));

    // function to check if browser is IE
    var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);

    // Ensure product media libraries are present
    if (!isIE11) {
      window.Shopify.loadFeatures([
        {
          name: 'shopify-xr',
          version: '1.0',
        },
        {
          name: 'model-viewer-ui',
          version: '1.0',
        }
      ],)
    }

    /* DESKTOP */
    this.collectionStartItem = $('.collection-start-item');
    this.collectionEndItem = $('.collection-end-item');
    this.collectionItemsCount = $('.collection-items-count');

    /*console.log(this.collectionStartItem);
    console.log(this.collectionEndItem);
    console.log(this.collectionItemsCount);*/

    /* MOBILE */
    this.mobileBreakpoint = 799;
    this.filteredProductsCount = $('.filtered-products-count');
    this.filteredProductsCountS = $('.filtered-products-count-s');
    /*let mobileLayout = window.matchMedia('(max-width: 798px)');
    if(mobileLayout.matches){}*/

    /* TOGGLE PANEL */
    this.sidebarSection = $(".sidebar-section");
    this.overlay = $('.ajax-cart__overlay');

    $(".toggle-filters-button").on('click', function(){
      window.PXUTheme.jsCollection.showMobileFilterPanel();
    });
        
    $(".close-filters-button, .ajax-cart__overlay").on('click', function(){
      window.PXUTheme.jsCollection.hideMobileFilterPanel();
    });
    /* END OF TOGGLE PANEL */

    //this.clearButtonInnerString = '<span class="icon clear-filter" data-icon="x" style="margin-right:4px;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span><span>Clear</span>';

    if (this.enable_sorting == true) {
      $('#sort-by').val($('#sort-by').data('default-sort'));
    }

    if (this.enable_filter == true || this.enable_sorting == true) {
      $('#tag_filter, #sort-by').on('change', function() {
        window.PXUTheme.jsCollection.filterURL();
      });
    }

    if ($('[data-option-filter]').length) {
      // Show enabled filter tags based on selected checkboxes
      $('[data-tag-filter-checkbox]:checked').each(function(){
        window.PXUTheme.jsCollection.multiTagFilter.showSelectedFilter($(this));
      })
    }

    // If breadcrumbs enabled and basic pagination is set, call breadcrumbs object
    if (this.enable_breadcrumb && this.pagination_type == 'basic_pagination') {
      window.PXUTheme.breadcrumbs.init(this.number_of_pages);
    }

    /* Collection sidebar filter */
    $('body').on('click', '[data-option-filter]', function(e) {
      e.preventDefault();

      $(this).find('input').prop('checked', true);

      window.PXUTheme.jsCollection.multiTagFilter.init($(this));
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    $('body').on('click', '[data-clear-filter]', function () {
      const $el = $(this).siblings('[data-option-filter]');
      const $productTagFilter = $('#tag_filter');

      $productTagFilter.find('option:eq(0)').prop('selected', true);
      window.PXUTheme.jsCollection.multiTagFilter.clearSelectedFilter($el);
      window.PXUTheme.scrollToTop($('.collection__content'));
    });

    if (this.ajax_faceted_filtering == true) {

      this.facetedFilterForm = $('[data-faceted-filter-form]');

      /* List filters */
      this.facetedFilterForm.on('change', function(e) {
        if($(e.target).hasClass('faceted-filter-group-display__list-item-input')) {
          window.PXUTheme.jsCollection.filterURL();
        }
      });

      /* Price filter */
      $('body').on('click', '.faceted-filter-group-display__submit', function (e) {
        e.preventDefault();

        let from = $('body').find('.faceted-filter-group-display__price-range-from input').val();
        if(!from){ from = "0"; }

        let to = $('body').find('.faceted-filter-group-display__price-range-to input').val();

        window.PXUTheme.jsCollection.filterURL({ 'filter.v.price.gte': from, 'filter.v.price.lte': to });
      });

      /* CLEAR GROUP FILTERS */
      $('body').on('click', '[data-faceted-filter] .faceted-filter-group-display__header-clear', function (e) {
        e.preventDefault();

        const filteGroup = $(this).parent().parent();
        filteGroup.find('input[type="checkbox"]:checked').prop('checked', false);

        window.PXUTheme.jsCollection.filterURL();
      });

      /* CLEAR ALL FILTERS */
      this.clearAllButton = $('.mobile-faceted-filter-clear-all');

      this.clearAllButton.on('click', function (e) {

        e.preventDefault;
        $(this).addClass('is-hidden');

        window.PXUTheme.jsCollection.hideMobileFilterPanel();

        $('body').find('.faceted-filter-group-display__list-item-input').each(function () {
          $(this).prop("checked", false);
        });

        /* Uodate view */
        let params = new URLSearchParams(window.location.search);
        var url = "/collections/" + window.PXUTheme.jsCollection.collection_handle + "?sort_by=" + params.get("sort_by");
        window.PXUTheme.jsCollection.updateView(url);
      });

      /* MOBILE - VIEW FILTERED PRODUCTS */
      this.filteredProductsCount.parent().on('click', function(){
        window.PXUTheme.jsCollection.hideMobileFilterPanel();
      });

    } else {

      /* Minimise default filters on mobile */
      $('.faceted-filtering-toggle-overlay').on('click', () => {
        window.PXUTheme.jsCollection.sidebarSection.toggleClass('are-active');
      });

      this.minimiseFilters();
    }
  },
  minimiseFilters: function(){
    if ($(window).width() < this.mobileBreakpoint) { // Mobile
      window.PXUTheme.jsCollection.sidebarSection.removeClass('are-active');
    } else { // Desktop
      window.PXUTheme.jsCollection.sidebarSection.addClass('are-active');
    }
  },
  showMobileFilterPanel: function(){
    this.sidebarSection.addClass('is-visible');
    this.overlay.addClass('is-visible');
  },
  hideMobileFilterPanel: function(){
    this.sidebarSection.removeClass('is-visible');
    this.overlay.removeClass('is-visible');
  },
  filterURL: function(queryParameters = {}) {

    var selectedOptions = [],
        query = '',
        currentTags = '',
        siteUrl = 'https://' + $.url('hostname');

    // check if language has been translated. Length equals one when default language (eg: '/') and greater than 1 when language is translated (eg: '/fr')
    if (window.PXUTheme.routes.root_url.length > 1) {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var url3 = $.url('3') ? $.url('3') + '/' : '';
      var path = url1 + url2 + url3;
    } else {
      var url1 = $.url('1') ? '/' + $.url('1') + '/' : '';
      var url2 = $.url('2') ? $.url('2') + '/' : '';
      var path = url1 + url2;
    }

    //Handle dropdowns if they exist
    if ($('#sort-by').length){
      query = $('#sort-by').val();
    } else {
      query = url('?sort_by');
    }

    if ($('#tag_filter').length){

      if ($('#tag_filter').data('default-collection') != $('#tag_filter').val()){
        var urlTag = $('#tag_filter').val().substr($('#tag_filter').val().lastIndexOf('/') + 1);

        if (urlTag != 'all'){
          if ($.inArray( urlTag, selectedOptions ) > -1){
            //Do nothing
          } else {
            selectedOptions.unshift(urlTag);
          }
        }
      }
    }

    //Add all checkbox values to array
    $('[data-option-filter] input:checked').each(function () {
      selectedOptions.push($(this).val());
    });

    selectedOptions = $.makeArray(selectedOptions);

    //console.log("SELECTED OPTIONS:", selectedOptions);

    //Loop through tags to create string to update page url
    $.each(selectedOptions, function(i, value){

      if (i != selectedOptions.length - 1) {
        currentTags += selectedOptions[i] + '+';
      } else {
        currentTags += selectedOptions[i];
      }

    });

    /* Reset query params */
    window.PXUTheme.queryParameters = queryParameters;

    window.PXUTheme.queryParameters.sort_by = query;

    query = '?' + $.param(window.PXUTheme.queryParameters);

    /* FACETED FILTERS */
    if (this.ajax_faceted_filtering == true) {
      let facetedFilterArray = [];

      $('.faceted-filter-group-display__list-item-label input:checked').each(function () {
        facetedFilterArray.push({ name: this.name, value: this.value });
      });

      if(facetedFilterArray.length > 0){
        query += "&" + $.param(facetedFilterArray);
      }
    }
    /* END OF FACETED FILTERS */

    //console.log("QUERY:", query);

    this.processUrl(path, currentTags, query);
  },
  /*addGroupClearButton: function(){
    var groupClearButton = $("<a></a>");
    groupClearButton.innerHTML = window.PXUTheme.jsCollection.clearButtonInnerString;
    groupClearButton.addClass('faceted-filter-group-display__header-clear');
    console.log(groupClearButton);
    $(_this).prepend(groupClearButton);
  },*/
  updateClearButtons: function(){

    /* SHOW/HIDE CLEAR ALL BUTTON */
    if($('body').find('.faceted-filter-group-display__list-item-input[type=checkbox]:checked').length == 0){

      this.clearAllButton.addClass('is-hidden');

    } else {

       this.clearAllButton.removeClass('is-hidden');
    }

    /* SHOW/HIDE CLEAR GROUP BUTTONS */
    $('body').find('.block__faceted-filtering').each(function () {

      var groupClearButton = $(this).find('.faceted-filter-group-display__header-clear');

      /* SHOW/HIDE CLEAR BUTTONS */ 
      if($(this).find('input[type=checkbox]:checked').length > 0){ // IF HAS CHECKED FILTERS

        groupClearButton.removeClass('is-hidden');

      } else { // IF DOESN'T HAVE CHECKED FILTERS

        groupClearButton.addClass('is-hidden');
      }
    });
  },
  async updateFilters(url) {
    try {
      const response = await fetch(`${url}&view=faceted-filter.json`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      console.log("UPDATE FILTERS DATA", data);

      if (!data.filter_groups || !data.filters) {
        throw new Error('API returned unexpected data format');
      }

      /* Pagination */
      if (data.pagination.start_item){
        this.collectionStartItem.text("1");
      }

      if (data.pagination.end_item){
        this.collectionEndItem.text(data.pagination.end_item);
      }
      /* END of Pagination */

      if (data.products_count){
        this.collectionItemsCount.text(data.products_count);
        this.filteredProductsCount.text(data.products_count);
        if (data.products_count > 1){
          this.filteredProductsCountS.removeClass('is-hidden');
        } else {
          this.filteredProductsCountS.addClass('is-hidden');
        }
      }

      /* UPDATE FILTER GROUP COUNTS */
      data.filter_groups.forEach(filterGroup => {
        const filterGroupBlock = window.PXUTheme.jsCollection.facetedFilterForm.find(`[data-faceted-filter="${filterGroup.name}"]`);

        if (!filterGroupBlock.length) return;

        const filterGroupCount = filterGroupBlock.find('.faceted-filter-group-summary__active-count');

        filterGroupCount.find('span').text(filterGroup.count);

        filterGroupCount.toggleClass('is-hidden', filterGroup.count == 0);
      });

      /* ENABLE ALL FILTERS */
      const filterInputs = $('body').find('.faceted-filter-group-display__list-item-input');

      filterInputs.prop("disabled", false);

      data.filters.forEach(filter => {

        const $filterInput = window.PXUTheme.jsCollection.facetedFilterForm.find(`input.faceted-filter-group-display__list-item-input[name="${filter.name}"]#${filter.input_id}`);

        //console.log(filter.name);
        //console.log(filter.value);

        if(!$filterInput.length) return;

        const $filterCount = $filterInput.nextAll('.faceted-filter-group-display__list-item-count').first();

        $filterCount.find('span').text(filter.count);

        if(filter.count == 0){
          $filterInput.prop('checked', false);
          $filterInput.prop('disabled', true);
        }
      });

    } catch (error) {
      console.log('Fetch error: ', error);
    }
  },
  processUrl: function (path, tags, query) {

    var query = query.replace(/\page=(\w+)&/, ''),
      urlString = '';

    urlString = path + tags + query;

    this.updateView(urlString);

  },
  updateView: function(filterURL) {
    var _this = this;
    $.ajax({
      type: 'GET',
      url: filterURL,
      beforeSend: function() {
        $('.collection-matrix').addClass('fadeOut animated loading-in-progress');
        $('.collection-matrix__wrapper .collection__loading-icon').fadeIn();
        _this.updateClearButtons();
      },
      success: function() {
        _this.updateFilters(this.url);
      },
      error: function(x, t, m) {
        console.log(x);
        console.log(t);
        console.log(m);
        location.replace(location.protocol + '//' + location.host + filterURL);

      },
      dataType: "html"
    }).then(function(data){

      const $breadcrumbContainer = $('.breadcrumb__container');
      const $collectionMatrix = $('.collection-matrix');
      const $collectionMain = $('[data-collection-main]');

      // Get and set new breadcrumb html
      const filteredBreadcrumb = $(data).find('.breadcrumb__container').html();
      $breadcrumbContainer.html(filteredBreadcrumb);

      // Remove loading animation
      $collectionMatrix.removeClass('fadeIn animated loading-in-progress');

      // Check for products
      const filteredData = $(data).find('.collection-matrix__wrapper');
      const filteredPageLinks = $(data).find('.container--pagination');
      const noProducts = $(data).find('.container--no-products-in-collection');

      if (filteredData.length) {
        // Add products to container
        $collectionMain.empty();
        $collectionMain.append(filteredData);
      } else {
        // Display no product message
        $collectionMain.empty();
        $collectionMain.append(noProducts);
      }

      $collectionMain.append(filteredPageLinks);

      window.history && window.history.pushState && window.history.pushState("", "", filterURL);

      // Initiate infinite scrolling on new products appended to collection grid
      if ($('[data-custom-pagination]').length) {
        window.PXUTheme.infiniteScroll.init();
      }

    });
  },
  multiTagFilter: {
    init: function ($el) {

      // Show filter and hide siblings
      this.showSelectedFilter($el);

      // Update url
      window.PXUTheme.jsCollection.filterURL();

      var urlIndex;
      if (window.PXUTheme.routes.root_url.length > 1) {
        urlIndex = 3
      } else {
        urlIndex = 2
      }

      // Hide filters if types or vendors is in URL (can't be combined)
      if ($.url(urlIndex) === 'types' || $.url(urlIndex) === 'vendors') {
        $('.block__tag-filter').remove();
      }

    },
    showSelectedFilter: function ($el) {
      const $sidebarToggleBlock = $el.parents('.sidebar-toggle-active');
      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.addClass('is-active');
      $filterItem.siblings(':not(.is-active)').addClass('is-hidden');
      $filterItem.find('[data-clear-filter]').removeClass('is-hidden');

      // If sidebar toggle is enabled, show filter in sidebar content
      if ($sidebarToggleBlock.length) {
        let $toggleBtn = $sidebarToggleBlock.find('[data-sidebar-block__toggle="closed"]');

        window.PXUTheme.jsSidebar.openSidebarBlock($toggleBtn);
      }

    },
    clearSelectedFilter: function ($el) {

      const $filterItem = $el.parents('.tag-filter__item');

      $filterItem.removeClass('is-active')
            .find('input').prop("checked", false);
      $filterItem.siblings()
            .removeClass('is-hidden');
      $filterItem.find('[data-clear-filter]')
            .addClass('is-hidden');

      //Update url
      window.PXUTheme.jsCollection.filterURL();
    }
  },
  unload: function($section) {
    $('#tag_filter, #sort-by').off();
    $('[data-option-filter]').off();
    $('[data-reset-filters]').off();
    $('[data-clear-filter]').off();
    window.PXUTheme.breadcrumbs.unload();

    $('.toggle-filters-button').off();
    $('.close-filters-button, .ajax-cart__overlay').off();
    $('[data-faceted-filter-form]').off();
    $('.faceted-filter-group-display__submit').off();
    $('[data-faceted-filter] .faceted-filter-group-display__header-clear').off();
    $('.filtered-products-count').off();
  }
}

/******/ })()
;